import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, CreditCard, ShieldCheck, HelpCircle, ArrowRight, MapPin, Video, Mail, Phone } from 'lucide-react';
export function FeesPage() {
  return <>
      {/* Hero */}
      <section className="bg-olive py-16 md:py-20" data-id="element-849">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-850">
          <div className="text-center max-w-3xl mx-auto" data-id="element-851">
            <span className="text-gold font-bold uppercase tracking-widest text-xs mb-4 block" data-id="element-852">
              FEES & POLICIES
            </span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight" data-id="element-853">
              Transparent <span className="italic text-cream" data-id="element-854">Pricing</span>
            </h1>
            <p className="text-white/80 text-base md:text-lg font-medium" data-id="element-855">
              Clear, straightforward fees with flexible payment options. No
              surprises.
            </p>
          </div>
        </div>
      </section>

      {/* Pricing Cards */}
      <section className="py-16 lg:py-20 bg-cream" data-id="element-856">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-857">
          <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-858">
            <div data-id="element-859">
              <div className="bg-white rounded-2xl p-8 border border-charcoal/10 h-full flex flex-col" data-id="element-860">
                <h3 className="font-heading text-xl font-bold text-charcoal mb-2" data-id="element-861">
                  Individual Session
                </h3>
                <div className="flex items-baseline gap-2 mb-4" data-id="element-862">
                  <span className="text-4xl font-bold text-olive" data-id="element-863">$160</span>
                  <span className="text-charcoal/50 font-medium" data-id="element-864">
                    / 50 minutes
                  </span>
                </div>
                <p className="text-charcoal/70 text-base font-medium mb-6 flex-grow" data-id="element-865">
                  One-on-one therapy sessions focused on your personal goals,
                  healing, and growth.
                </p>
                <ul className="space-y-3 mb-8" data-id="element-866">
                  <li className="flex items-start gap-2 text-base text-charcoal/80" data-id="element-867">
                    <CheckCircle2 size={18} className="text-olive flex-shrink-0 mt-0.5" data-id="element-868" />
                    <span data-id="element-869">In-person or Virtual</span>
                  </li>
                  <li className="flex items-start gap-2 text-base text-charcoal/80" data-id="element-870">
                    <CheckCircle2 size={18} className="text-olive flex-shrink-0 mt-0.5" data-id="element-871" />
                    <span data-id="element-872">Personalized treatment plan</span>
                  </li>
                </ul>
                <a href="https://esthermensah.janeapp.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-olive hover:bg-olive/90 text-white px-6 py-3 rounded-full font-bold text-base transition-all w-full min-h-[48px] mt-auto" data-id="element-873">
                  Book Individual
                </a>
              </div>
            </div>

            <div data-id="element-874">
              <div className="bg-white rounded-2xl p-8 border-2 border-olive shadow-soft-lg relative h-full flex flex-col" data-id="element-875">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-olive text-white px-4 py-1 rounded-full text-sm font-bold tracking-wide uppercase whitespace-nowrap" data-id="element-876">
                  Most Popular
                </div>
                <h3 className="font-heading text-xl font-bold text-charcoal mb-2 mt-2" data-id="element-877">
                  Couples Session
                </h3>
                <div className="flex items-baseline gap-2 mb-4" data-id="element-878">
                  <span className="text-4xl font-bold text-olive" data-id="element-879">$180</span>
                  <span className="text-charcoal/50 font-medium" data-id="element-880">
                    / 50 minutes
                  </span>
                </div>
                <p className="text-charcoal/70 text-base font-medium mb-6 flex-grow" data-id="element-881">
                  Joint sessions to improve communication, resolve conflicts,
                  and rebuild your connection.
                </p>
                <ul className="space-y-3 mb-8" data-id="element-882">
                  <li className="flex items-start gap-2 text-base text-charcoal/80" data-id="element-883">
                    <CheckCircle2 size={18} className="text-olive flex-shrink-0 mt-0.5" data-id="element-884" />
                    <span data-id="element-885">In-person or Virtual</span>
                  </li>
                  <li className="flex items-start gap-2 text-base text-charcoal/80" data-id="element-886">
                    <CheckCircle2 size={18} className="text-olive flex-shrink-0 mt-0.5" data-id="element-887" />
                    <span data-id="element-888">Conflict resolution tools</span>
                  </li>
                </ul>
                <a href="https://esthermensah.janeapp.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-olive hover:bg-olive/90 text-white px-6 py-3 rounded-full font-bold text-base transition-all w-full min-h-[48px] mt-auto" data-id="element-889">
                  Book Couples
                </a>
              </div>
            </div>

            <div data-id="element-890">
              <div className="bg-white rounded-2xl p-8 border border-charcoal/10 h-full flex flex-col" data-id="element-891">
                <h3 className="font-heading text-xl font-bold text-charcoal mb-2" data-id="element-892">
                  Family Session
                </h3>
                <div className="flex items-baseline gap-2 mb-4" data-id="element-893">
                  <span className="text-4xl font-bold text-olive" data-id="element-894">$180</span>
                  <span className="text-charcoal/50 font-medium" data-id="element-895">
                    / 50 minutes
                  </span>
                </div>
                <p className="text-charcoal/70 text-base font-medium mb-6 flex-grow" data-id="element-896">
                  Therapeutic support for families navigating conflict and life
                  transitions together.
                </p>
                <ul className="space-y-3 mb-8" data-id="element-897">
                  <li className="flex items-start gap-2 text-base text-charcoal/80" data-id="element-898">
                    <CheckCircle2 size={18} className="text-olive flex-shrink-0 mt-0.5" data-id="element-899" />
                    <span data-id="element-900">In-person or Virtual</span>
                  </li>
                  <li className="flex items-start gap-2 text-base text-charcoal/80" data-id="element-901">
                    <CheckCircle2 size={18} className="text-olive flex-shrink-0 mt-0.5" data-id="element-902" />
                    <span data-id="element-903">All family configurations</span>
                  </li>
                </ul>
                <a href="https://esthermensah.janeapp.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-olive hover:bg-olive/90 text-white px-6 py-3 rounded-full font-bold text-base transition-all w-full min-h-[48px] mt-auto" data-id="element-904">
                  Book Family
                </a>
              </div>
            </div>
          </div>

          {/* Free Consultation */}
          <div data-id="element-905">
            <div className="bg-olive/10 rounded-2xl p-8 text-center border border-olive/15 max-w-3xl mx-auto" data-id="element-906">
              <h3 className="font-heading text-xl font-bold text-charcoal mb-2" data-id="element-907">
                Free 15-Minute Consultation
              </h3>
              <p className="text-charcoal/70 text-base font-medium mb-6 max-w-lg mx-auto" data-id="element-908">
                Not sure where to start? Book a free phone consultation to
                discuss your needs and see if we're a good fit. No commitment
                required.
              </p>
              <a href="https://esthermensah.janeapp.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-olive hover:bg-olive/90 text-white px-8 py-3.5 rounded-full font-bold text-base transition-all min-h-[48px]" data-id="element-909">
                Book Free Consultation
                <ArrowRight size={16} className="ml-2" data-id="element-910" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Insurance & Payment */}
      <section className="py-16 lg:py-20 bg-white" data-id="element-911">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-912">
          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-913">
            <div data-id="element-914">
              <div className="bg-cream rounded-2xl p-8 h-full" data-id="element-915">
                <div className="flex items-center gap-3 mb-4" data-id="element-916">
                  <div className="w-12 h-12 rounded-xl bg-olive/10 flex items-center justify-center text-olive" data-id="element-917">
                    <ShieldCheck size={24} data-id="element-918" />
                  </div>
                  <h3 className="font-heading text-xl font-bold text-charcoal" data-id="element-919">
                    Insurance Coverage
                  </h3>
                </div>
                <div className="bg-olive/15 border-2 border-olive/30 rounded-xl p-5 mb-6" data-id="element-920">
                  <p className="text-charcoal font-extrabold text-base leading-relaxed" data-id="element-921">
                    Direct billing for most major health insurance such as
                    Manulife, Canada Life, TELUS Health, Equitable Life of
                    Canada and many more.
                  </p>
                </div>

                <p className="text-charcoal/70 text-base font-medium mb-6 leading-relaxed" data-id="element-922">
                  Services may be covered by your health insurance or employee
                  benefit plan. I provide detailed receipts for reimbursement
                  through your insurance provider.
                </p>

                <div className="space-y-4" data-id="element-923">
                  <div className="bg-gold/10 border border-gold/20 rounded-xl p-4" data-id="element-924">
                    <p className="text-charcoal font-bold text-sm leading-relaxed" data-id="element-925">
                      Employee Assistance Programs (EAPs) and Health Spending
                      Accounts also cover therapy provided by a Registered
                      Social Worker.
                    </p>
                  </div>
                  <div className="bg-olive/10 border border-olive/20 rounded-xl p-4" data-id="element-926">
                    <p className="text-charcoal font-bold text-sm leading-relaxed" data-id="element-927">
                      Social Work services are considered eligible health
                      expenses and may be claimed on your personal income tax
                      return.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div data-id="element-928">
              <div className="bg-cream rounded-2xl p-8 h-full" data-id="element-929">
                <div className="flex items-center gap-3 mb-4" data-id="element-930">
                  <div className="w-12 h-12 rounded-xl bg-olive/10 flex items-center justify-center text-olive" data-id="element-931">
                    <CreditCard size={24} data-id="element-932" />
                  </div>
                  <h3 className="font-heading text-xl font-bold text-charcoal" data-id="element-933">
                    Payment & Policies
                  </h3>
                </div>
                <ul className="space-y-3 text-base text-charcoal/80 font-medium mb-6" data-id="element-934">
                  <li className="flex justify-between border-b border-charcoal/10 pb-3" data-id="element-935">
                    <span data-id="element-936">Accepted Methods</span>
                    <span className="font-bold text-charcoal" data-id="element-937">
                      Credit Card, e-Transfer
                    </span>
                  </li>
                  <li className="flex justify-between border-b border-charcoal/10 pb-3" data-id="element-938">
                    <span data-id="element-939">Payment Due</span>
                    <span className="font-bold text-charcoal" data-id="element-940">
                      At time of session
                    </span>
                  </li>
                  <li className="flex justify-between border-b border-charcoal/10 pb-3" data-id="element-941">
                    <span data-id="element-942">Cancellation Notice</span>
                    <span className="font-bold text-charcoal" data-id="element-943">48 hours</span>
                  </li>
                  <li className="flex justify-between" data-id="element-944">
                    <span data-id="element-945">Late Cancellation Fee</span>
                    <span className="font-bold text-charcoal" data-id="element-946">
                      Full session rate
                    </span>
                  </li>
                </ul>

                <div className="bg-white/50 rounded-xl p-4 mb-4 border border-charcoal/5" data-id="element-947">
                  <p className="text-sm text-charcoal/80 font-medium leading-relaxed" data-id="element-948">
                    You can cancel or reschedule appointments via the Jane app
                    or send an email to{' '}
                    <a href="mailto:esther@esthermensahcounselling.com" className="font-bold hover:text-olive transition-colors" data-id="element-949">
                      esther@esthermensahcounselling.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Appointment Options */}
      <section className="py-16 lg:py-20 bg-olive/5 border-t border-charcoal/5" data-id="element-950">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-951">
          <div className="text-center mb-10" data-id="element-952">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-charcoal mb-3" data-id="element-953">
              Appointment Options
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-954">
            <div className="bg-white rounded-2xl p-8 border border-charcoal/5 shadow-sm flex flex-col items-center text-center" data-id="element-955">
              <div className="w-16 h-16 rounded-full bg-olive/10 flex items-center justify-center text-olive mb-6" data-id="element-956">
                <MapPin size={28} data-id="element-957" />
              </div>
              <h3 className="font-heading text-xl font-bold text-charcoal mb-4" data-id="element-958">
                In-Person Sessions
              </h3>
              <p className="text-charcoal/80 font-medium mb-8" data-id="element-959">
                In-person sessions are offered at{' '}
                <strong data-id="element-960">370 Queens Ave, London, Ontario.</strong>
              </p>
              <Link to="/contact" className="mt-auto inline-flex items-center justify-center bg-white border-2 border-olive text-olive hover:bg-olive hover:text-white px-6 py-3 rounded-full font-bold text-base transition-all w-full min-h-[48px]" data-id="element-961">
                View Location Details
              </Link>
            </div>

            <div className="bg-white rounded-2xl p-8 border border-charcoal/5 shadow-sm flex flex-col items-center text-center" data-id="element-962">
              <div className="w-16 h-16 rounded-full bg-olive/10 flex items-center justify-center text-olive mb-6" data-id="element-963">
                <Video size={28} data-id="element-964" />
              </div>
              <h3 className="font-heading text-xl font-bold text-charcoal mb-4" data-id="element-965">
                Virtual / Online Sessions
              </h3>
              <p className="text-charcoal/80 font-medium mb-8" data-id="element-966">
                Virtual/Online sessions are offered across Ontario using a
                secure HIPAA-compliant platform.
              </p>
              <a href="https://esthermensah.janeapp.com/" target="_blank" rel="noopener noreferrer" className="mt-auto inline-flex items-center justify-center bg-olive hover:bg-olive/90 text-white px-6 py-3 rounded-full font-bold text-base transition-all w-full min-h-[48px]" data-id="element-967">
                Book an Appointment
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 lg:py-20 bg-cream" data-id="element-968">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-969">
          <div className="text-center mb-10" data-id="element-970">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-charcoal mb-3" data-id="element-971">
              Frequently Asked Questions
            </h2>
          </div>

          <div className="space-y-4 mb-16" data-id="element-972">
            <div data-id="element-973">
              <div className="bg-white rounded-xl p-6 border border-charcoal/5" data-id="element-974">
                <div className="flex items-start gap-3" data-id="element-975">
                  <HelpCircle size={20} className="text-olive flex-shrink-0 mt-0.5" data-id="element-976" />
                  <div data-id="element-977">
                    <h3 className="font-bold text-charcoal mb-2" data-id="element-978">
                      Do I need a referral?
                    </h3>
                    <p className="text-charcoal/70 text-base font-medium" data-id="element-979">
                      No referral is needed. You can book directly through our
                      website or by calling the office.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-980">
              <div className="bg-white rounded-xl p-6 border border-charcoal/5" data-id="element-981">
                <div className="flex items-start gap-3" data-id="element-982">
                  <HelpCircle size={20} className="text-olive flex-shrink-0 mt-0.5" data-id="element-983" />
                  <div data-id="element-984">
                    <h3 className="font-bold text-charcoal mb-2" data-id="element-985">
                      How long does therapy take?
                    </h3>
                    <p className="text-charcoal/70 text-base font-medium" data-id="element-986">
                      The duration varies based on your needs and goals. Some
                      clients see improvement in 6-8 sessions, while others
                      benefit from longer-term support. We'll discuss this
                      during your consultation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-987">
              <div className="bg-white rounded-xl p-6 border border-charcoal/5" data-id="element-988">
                <div className="flex items-start gap-3" data-id="element-989">
                  <HelpCircle size={20} className="text-olive flex-shrink-0 mt-0.5" data-id="element-990" />
                  <div data-id="element-991">
                    <h3 className="font-bold text-charcoal mb-2" data-id="element-992">
                      Is virtual therapy as effective as in-person?
                    </h3>
                    <p className="text-charcoal/70 text-base font-medium" data-id="element-993">
                      Research shows that virtual therapy is equally effective
                      for most concerns. It also offers greater flexibility and
                      accessibility, especially for those across Ontario.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-994">
              <div className="bg-white rounded-xl p-6 border border-charcoal/5" data-id="element-995">
                <div className="flex items-start gap-3" data-id="element-996">
                  <HelpCircle size={20} className="text-olive flex-shrink-0 mt-0.5" data-id="element-997" />
                  <div data-id="element-998">
                    <h3 className="font-bold text-charcoal mb-2" data-id="element-999">
                      What if I need to cancel?
                    </h3>
                    <p className="text-charcoal/70 text-base font-medium" data-id="element-1000">
                      Please provide at least 48 hours notice for cancellations.
                      Late cancellations or no-shows will be charged the full
                      session rate.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-1001">
              <div className="bg-white rounded-xl p-6 border border-charcoal/5" data-id="element-1002">
                <div className="flex items-start gap-3" data-id="element-1003">
                  <HelpCircle size={20} className="text-olive flex-shrink-0 mt-0.5" data-id="element-1004" />
                  <div data-id="element-1005">
                    <h3 className="font-bold text-charcoal mb-2" data-id="element-1006">
                      What insurance do you accept?
                    </h3>
                    <p className="text-charcoal/70 text-base font-medium" data-id="element-1007">
                      I provide detailed receipts that you can submit to your
                      insurance provider for reimbursement. Please check with
                      your provider to ensure they cover "Registered Social
                      Workers".
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center bg-white rounded-2xl p-8 border border-charcoal/5 shadow-sm" data-id="element-1008">
            <h3 className="font-heading text-xl font-bold text-charcoal mb-4" data-id="element-1009">
              For more information or inquiries:
            </h3>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-1010">
              <a href="mailto:esther@esthermensahcounselling.com" className="flex items-center gap-2 text-olive hover:text-gold font-bold transition-colors" data-id="element-1011">
                <Mail size={20} data-id="element-1012" />
                esther@esthermensahcounselling.com
              </a>
              <a href="tel:5489000692" className="flex items-center gap-2 text-olive hover:text-gold font-bold transition-colors" data-id="element-1013">
                <Phone size={20} data-id="element-1014" />
                548-900-0692
              </a>
            </div>
          </div>
        </div>
      </section>
    </>;
}